import { NavLink, Outlet } from 'react-router-dom';
import { CalendarDays, Home, List, Plus, Settings } from 'lucide-react';
import { cn } from '../lib/utils';

const navItems = [
  { to: '/', label: '홈', end: true, icon: Home },
  { to: '/people', label: '목록', icon: List },
  { to: '/calendar', label: '달력', icon: CalendarDays },
  { to: '/settings', label: '설정', icon: Settings },
];

export const AppShell = () => (
  <div className="min-h-[100dvh] bg-background font-body text-foreground">
    <div className="mx-auto flex min-h-[100dvh] w-full max-w-[720px] flex-col">
      <header className="relative flex h-[calc(74px+env(safe-area-inset-top))] shrink-0 items-end pb-3 pl-[calc(20px+env(safe-area-inset-left))] pr-[calc(20px+env(safe-area-inset-right))]">
        <NavLink to="/" className="absolute left-1/2 flex -translate-x-1/2 items-center">
          <img
            src="/daykeeper-logo-blue.png"
            alt="DayKeeper"
            className="h-[37px] w-[37px] object-contain"
          />
        </NavLink>
        <NavLink
          to="/add"
          className="ml-auto flex h-11 w-11 items-center justify-center rounded-full text-foreground transition-colors hover:bg-secondary"
          aria-label="새 대상 또는 날짜 추가"
        >
          <Plus className="h-5 w-5" strokeWidth={2.2} aria-hidden="true" />
        </NavLink>
      </header>

      <main className="flex-1 overflow-x-hidden pb-[calc(108px+env(safe-area-inset-bottom))] pl-[calc(20px+env(safe-area-inset-left))] pr-[calc(20px+env(safe-area-inset-right))]">
        <Outlet />
      </main>

      <nav className="fixed bottom-[calc(10px+env(safe-area-inset-bottom))] left-[calc(12px+env(safe-area-inset-left))] right-[calc(12px+env(safe-area-inset-right))] z-20 mx-auto max-w-[696px] rounded-[24px] border border-black/10 bg-white/90 px-1.5 py-1.5 shadow-[0_10px_36px_rgba(0,0,0,0.12)] backdrop-blur-xl">
        <div className="grid grid-cols-4">
          {navItems.map((item) => {
            const Icon = item.icon;
            return (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.end}
                className={({ isActive }) =>
                  cn(
                    'flex min-h-[54px] flex-col items-center justify-center gap-0.5 rounded-[18px] text-xs font-medium transition-colors',
                    isActive
                      ? 'text-primary'
                      : 'text-muted-foreground hover:bg-secondary/70 hover:text-foreground',
                  )
                }
              >
                <Icon className="h-[22px] w-[22px]" strokeWidth={2} aria-hidden="true" />
                {item.label}
              </NavLink>
            );
          })}
        </div>
      </nav>
    </div>
  </div>
);
